import { useEffect } from 'react';
import { Auth } from 'aws-amplify';

import { deleteDecagonIdentity } from 'api/jalapeno';
import Loader from 'honeydew/Loader';
import logError from 'utils/errorUtils';

function Logout() {
    useEffect(() => {
        async function signOut() {
            try {
                await deleteDecagonIdentity();
            } catch (error) {
                logError(error);
            }
            await Auth.signOut();
            window.location.href = '/login';
        }
        signOut();
    }, []);

    return (
        <div className="mt-80 flex justify-center p-20">
            <Loader />
        </div>
    );
}

export { Logout as Component };
